export default __webpack_public_path__ + "static/img-tilapia-500x325-b1813cbfcaf06bd8a067a42bf8d1b50e.png";